export const LOGOUT_BROADCAST_CHANNEL_ID = "accumulus_app_logout";
export const DISMISS_IDLE_BROADCAST_CHANNEL_ID = "accumulus_app_dismiss_idle";
